
/*
ประเภทการแจงนับ
*/

// อินเตอร์เฟซCodeสถานะ
export enum APIResponseCodeType {
    'success' = 1,    // ความสำเร็จ
    'error' = 0,    // ล้มเหลว
    'redirect' = -1,   // เปลี่ยนเส้นทาง
    'page' = 2,    // กระโดดหน้า
}

// โหมดเพจ
export enum PageMode {
    'ADD' = 'add',    // เพิ่มไปที่
    'EDIT' = 'edit',   // แก้ไข
}

// ประเภทการจัดการคำสั่งซื้อ
export enum OrderType {
    'all' = '', //ทั้งหมด
    'wait' = 0, //ที่จะต้องจ่าย
    'finish' = 1, //สมบูรณ์
}